import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniAnswer } from "./UniAnswer";
import { DAO } from "./DAO";
import { WS } from "./WS";
import { API, ApiResult } from "./API";
import dayjs from "dayjs";
import { Member } from "./Member";
import { UniForm } from "./UniForm";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import { FillCommonAnswer } from "./UniAnswer_CommonForm";

export class UniAnswerDAO {
  static async Insert(data: UniAnswer): Promise<UniAnswer> {
    let refetch_data = await DAO.Insert(UniAnswer, data);
    return refetch_data;
  }
  static async Delete(data: UniAnswer): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(UniAnswer, data.guid);
    return effect_rows_cnt;
  }
  static async DB_Update(data: UniAnswer): Promise<UniAnswer> {
    let refetch_data = await DAO.Update(UniAnswer, data);
    return refetch_data;
  }

  static async WS_Update(data: UniAnswer): Promise<UniAnswer> {
    let api_rslt: ApiResult = await WS.CallWS("uni_answer/update", data);

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(UniAnswer, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
  static async WS_Update_完成問卷時間(data: UniAnswer) {
    data.rec_dt = dayjs().format("YYYY/MM/DD HH:mm:ss");

    let api_rslt: ApiResult = await WS.CallWS("uni_answer/update_rec_dt", data);
    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(UniAnswer, api_rslt.data);
    } else {
      console.log("error");
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async UpdateOneField(find_data: UniAnswer, field: string, value: any) {
    (find_data as any)[field] = value;

    let re = await DAO.UpdateOnly(UniAnswer, find_data, [field]);

    return re;
  }

  static async Select(uni_form_guid: string | null): Promise<UniAnswer[]> {
    let cond =
      " WHERE (1=1) " +
      // + " AND " + Cnd.尚未刪除()
      " AND " +
      Cnd.指定所屬主檔(uni_form_guid) +
      // + " AND " + Cnd.指定日期範圍(sD, eD)
      Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniAnswer, cond);
    return data_list;
  }

  /** 撈出本場次，所有受檢者，的特作問卷 */
  static async Select_指定場次的特作答案列表(
    project_guid: string
  ): Promise<UniAnswer[]> {
    let cond =
      " WHERE (1=1) " +
      " AND " +
      Cnd.指定場次(project_guid) +
      " AND " +
      Cnd.是特殊作業();

    let data_list = await DAO.Select(UniAnswer, cond);
    return data_list;
  }

  static async Select_指定場次的一般問卷答案列表(
    project_guid: string
  ): Promise<UniAnswer[]> {
    let cond =
      " WHERE (1=1) " +
      " AND " +
      Cnd.指定場次(project_guid) +
      " AND " +
      Cnd.是一般問卷();

    let data_list = await DAO.Select(UniAnswer, cond);
    return data_list;
  }
  //(member: Member): Promise<UniAnswer>

  static async Insert_空白的一般問卷_並帶入基本資料(
    member: Member,
    uni_form: UniForm
  ) {
    let data = new UniAnswer();

    data.member_guid = member.guid; // member
    data.form_guid = uni_form.guid; // form

    FillCommonAnswer(data, member, uni_form.guid); // 填入基本資料

    let refetch_data = await DAO.Insert(UniAnswer, data);
    return refetch_data;
  }

  static async Update_重新帶入基本資料(ans: UniAnswer, member: Member) {
    let update_only_columns = FillCommonAnswer(ans, member, ans.form_guid); // 填入基本資料

    if (update_only_columns.length === 0) {
      return ans;
    }

    let re = await DAO.UpdateOnly(UniAnswer, ans, update_only_columns);
    return re;
  }

  /** 對指定 Member
   * 新增 或 更新 指定 Anwser (缺少的 Insert，已有的 且 要覆蓋基本資料，再 Update)
   *
   */
  static async Save_新增或更新一般問卷Answers(
    sel_member: Member,
    sel_curr_common_forms: UniForm[],
    is_覆蓋基本資料: boolean
  ) {
    //#region Valid

    // 檢查是否都是當前版本的 Forms
    let not_curr_forms = sel_curr_common_forms.filter((x) => x.is_curr === 0);
    if (not_curr_forms.length !== 0) {
      throw new_ErrorAlert("456864 必須都是 curr=1");
    }

    //#endregion

    // 這裡再次篩選，以 member 現在身上掛的一般問卷為準(至少確保 畫面上看到的 跟 Answer 數量相同)
    // SpwkUtilV3.FUNC_GUID_F04 < 45歲(使用年相減) 的會被排除
    let common_func_guids = sel_member.getCommonUniFuncGuids();
    let member_sel_common_forms = sel_curr_common_forms.filter((x) =>
      common_func_guids.includes(x.func_guid)
    );

    //#region 取得所有 一般問卷 的 Answers
    // 取得此受檢者的所有答案
    let __all_answers: UniAnswer[] = await UniAnswerDAO.DB_Select_ByMemberGuid(
      sel_member.guid
    );
    // 只取得 一般問卷 的答案
    let common_quest_answers: UniAnswer[] = __all_answers.filter(
      (answer) => answer.IsSpwk() === false
    ); //answer.form_guid 有字串的話代表是一般問卷的答案
    //#endregion

    for (const sel_form of member_sel_common_forms) {
      // 對所有選擇的一般問卷Form, 看看是否已經在原本的 AnswerList 中了
      let ans_list = common_quest_answers.filter(
        (x) => x.func_guid === sel_form.func_guid
      );

      if (ans_list.length === 0) {
        console.log(
          "Insert 一般問卷Ans: " +
            sel_member.member_code +
            " " +
            sel_member.member_name +
            ": [" +
            sel_form.form_code +
            "]"
        );
        await UniAnswerDAO.Insert_空白的一般問卷_並帶入基本資料(
          sel_member,
          sel_form
        );
      } else if (ans_list.length === 1) {
        // pass; 最後再一次更新原本在資料庫的 一般問卷 基本資料
      } else {
        throw new_ErrorAlert("468434 Answer 有重複的 func_guid !!!");
      }
    }

    if (is_覆蓋基本資料) {
      // 原本已經存在的 ans_list，全部都要 更新基本資料
      for (const ans of common_quest_answers) {
        // if (ans.IsQuestDone()) {
        //   throw new Error(`${sel_member.serno} ${sel_member.member_code} ${sel_member.member_name} 已經填寫，無法再次覆蓋! ans:${ans.serno}`);
        // }

        console.log(
          "Update 一般問卷Ans: " +
            sel_member.member_code +
            " " +
            sel_member.member_name +
            ": [" +
            ans.form_guid +
            "] ans_serno='" +
            ans.serno +
            "'"
        );
        await UniAnswerDAO.Update_重新帶入基本資料(ans, sel_member);
      }
    }
  }

  //--------------------------------------------------------------------------------------
  static async DB_FetchByGuid(guid: string): Promise<UniAnswer> {
    let data = await DAO.FetchByGuid(UniAnswer, guid);
    return data;
  }

  static async WS_FetchByGuid(guid: string): Promise<UniAnswer> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_answer/fetch_by_guid",
      { guid: guid } // answer_guid
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(UniAnswer, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async DB_Select_ByMemberGuid(
    member_guid: string | null
  ): Promise<UniAnswer[]> {
    let cond = " WHERE (1=1) " + " AND " + ` member_guid='${member_guid}' `;

    let data_list = DAO.Select(UniAnswer, cond);
    return data_list;
  }

  static async WS_Select_ByMemberGuid(
    member_guid: string | null
  ): Promise<UniAnswer[]> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_answer/select_by_member_guid",
      { member_guid: member_guid }
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniAnswer, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
}

class Cnd {
  static 是特殊作業() {
    return ` (base_form_guid<>'') `;
  }
  static 指定場次(project_guid: string) {
    return ` (project_guid='${project_guid}') `;
  }
  static 是一般問卷() {
    return ` (form_guid<>'' AND base_form_guid='' AND spwk_func_guid_list='' AND spwk_form_guid_list='') `;
  }

  static 指定所屬主檔(form_guid: string | null) {
    return ` (form_guid='${form_guid}') `;
  }

  static 指定所屬特作(uni_form_guids: string[] | null) {
    let ary: any[] = [];
    uni_form_guids?.forEach((guid: string) => {
      ary.push(`func_guid='${guid}'`);
    });
    ary.join(" OR ");

    return ary.join(" OR ");
  }

  static OrderBy預設排序() {
    return ` ORDER BY chapter, serno `;
  }
}

/*
 * 回傳 Answer，如果輸入的 guid 是 undefined，則也先回傳 undefined 代表還沒取得數值
 * null 代表有撈資料但是沒有撈到對應的 answer
 */
export function useUniAnswer(guid: string | undefined) {
  const ctx = useAppContext();

  const [_UniAnswer, set_UniAnswer] = useState<UniAnswer | null | undefined>(
    undefined
  );

  async function refresh_UniAnswer() {
    try {
      if (guid === undefined) {
        set_UniAnswer(undefined); // 輸入的參數尚未準備好
        return;
      }

      const data = await UniAnswerDAO.DB_FetchByGuid(guid);
      set_UniAnswer(data);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  }

  useEffect(() => {
    refresh_UniAnswer();
  }, [guid]);

  return { _UniAnswer, set_UniAnswer, refresh_UniAnswer };
}

export function useUniAnswerList(form_guid: string) {
  const ctx = useAppContext();

  const [_UniAnswerList, set_UniAnswerList] = useState<UniAnswer[]>([]);

  async function refresh_UniAnswerList() {
    try {
      const data_list = await UniAnswerDAO.Select(form_guid);
      set_UniAnswerList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  }

  useEffect(() => {
    refresh_UniAnswerList();
  }, [form_guid]);

  return { _UniAnswerList, set_UniAnswerList, refresh_UniAnswerList };
}
